import styled from 'styled-components';

import { Spacer } from '@ontruck/orc';

const StyledShipmentTitle = styled(Spacer).attrs(() => ({ mBottom: 'S' }))`
  font-size: ${(props) => props.theme.base.textSizes.XL};
  font-weight: bold;
  line-height: normal;
`;

export default StyledShipmentTitle;
